import { forwardRef } from "react";

import Icon from "@/components/Icon";
import AiSparkWithGradientSVG from "./ai-spark-with-gradient.svg.jsx";
import type { IconProps } from "@/components/Icon/Icon";

const AiSparkWithGradientIcon = forwardRef<
  SVGSVGElement,
  Omit<IconProps, "SvgComponent">
>((props, ref) => {
  return <Icon ref={ref} SvgComponent={AiSparkWithGradientSVG} {...props} />;
});

export default AiSparkWithGradientIcon;
